// extracted by mini-css-extract-plugin
module.exports = {"bullet":"styles_bullet__ELN_n","dot":"styles_dot__D_Hjd","active":"styles_active__c_8zc"};